export type CameraAttributes = {
  id: string;
  path: string;
};

export enum ImageVariant {
  Small1x = 'small1x',
  Medium1x = 'medium1x',
  Large1x = 'large1x',
  Small2x = 'small2x',
  Medium2x = 'medium2x',
  Large2x = 'large2x',
  Small3x = 'small3x',
  Medium3x = 'medium3x',
  Large3x = 'large3x',
  Public = 'public',
  Hd = 'hd',
}

export enum ImageVariantSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export type MediaAsset = {
  id: string;
  path: string;
  mimeType: string | null;
};
